import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'root/view/base';

var Notion_Send = View.extend({
    databases: null,

    database_id: '',

    form_value : {
        title: '',
    },

    events: {
        'click .dropdown-database li.database' : 'onSelectDatabase',
        'submit form'                        : 'onSubmit',
        'click .reconnect'                   : 'onReconnect'
    },

    dom_handlers: {
        onSelectDatabase: function(e) {
            this.database_id = $(e.currentTarget).data('id');

            this.renderDatabases();
        },

        onReconnect: function(e) {
            var connected_app = Cache.connected_app_oauth.get(Cache.integration_notion.findWhere({project_id: this.model.get('project_id')})?.get('app_id') || 0);

            if (connected_app) {
                Modals.reconnectConnectedApp(connected_app.get('app_type'), connected_app, () => {
                    Modals.sendToNotion(this.model.id);
                });
            } else {
                window.parent.location = '/account/connected_app';
            }
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            if (!this.database_id) {
                UI.error('Please select a Database');
                return;
            }

            this.$el.find('button[type="submit"]').prop('disabled', true).addClass('loading');

            this.$el.find('.mask-light').show();
            this.$el.find('.progress-loader').width('0%').show();
            var progress = 0;
            var timeout = setInterval(() => {
                progress = Math.min(90, progress + Math.random() * 5);
                this.$el.find('.progress-loader').width(progress + '%');
            }, 50);

            Cache.app.request({
                action: 'integration/sendFeedbackToNotion',
                context: this,
                data: _.extend(form_data, {
                    feedback_id : this.model.get('id'),
                    database_id  : this.database_id,
                    title       : form_data.title,
                    description : form_data.description,
                }),
                success: function(response) {
                    this.model.set('notion_url', response.notion_url);

                    setTimeout(() => {
                        UI.success('Task created in Notion');
                        this.trigger('submit:success');
                    }, 800);  // wait for animation to finish
                },
                complete: function() {
                    this.$el.find('button[type="submit"]').prop('disabled', false).removeClass('loading');

                    clearInterval(timeout);
                    this.$el.find('.progress-loader').width('100%');
                }
            });
        }
    },

    initialize: function() {
        this.database_id = Cache.integration_notion.findWhere({project_id: Cache.default_project_id})?.get('notion_database_id') || '';

        this.form_value  = {
            title: '',
        };

        if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
            this.title = 'Feedback for ' + this.model.get('page');
        } else {
            this.title = 'Feedback #' + Util.padLeft(this.model.id, '000000');
        }

        if (this.model.get('title')) {
            this.form_value.title = this.model.get('title');
        }
    },

    loadSendOptions: function() {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type : 'notion',
                project_id: this.model.get('project_id')
            },
            context: this,
            success: function(response) {
                if (response.databases && response.databases.length) {
                    this.databases = response.databases;

                    this.renderDatabases();
                } else {
                    var message = '<div class="error-dialog padding-30">' +
                                        '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
                                        '<h3>Authentication failed</h3>' +
                                        '<p class="info">We couldn\'t connect to your Notion account.</p>' +
                                        (Cache.app.isAdmin() ?
                                        '<button class="reconnect primary medium">Reconnect Notion</button>' +
                                        '<div class="divider-20"></div>' : '') +
                                    '</div>';

                    this.$el.html(message);
                }
            },
            complete: function() {
                this.$el.find('form button:submit').prop('disabled', false);
            }
        });
    },

    searchDatabase: function(database_id) {
        var result = false;

        if (this.databases) {
            this.databases.forEach(function(database) {
                if (database.notion_database_id == database_id) {
                    result = database;
                }
            });
        }

        return result;
    },

    renderDatabases: function() {
        var database_items = '';

        if (this.databases) {
            this.databases.forEach((database) => {
                database_items += '<li class="database' + (this.database_id == database.notion_database_id ? ' selected' : '') + '" data-id="' + database.notion_database_id + '"' + '>' +
                                    Util.htmlEntities((database.notion_database_title.trim() !== '') ? database.notion_database_title : 'No name' ) +
                                 '</li>';
            });
        }

        var database_selected = this.searchDatabase(this.database_id);

        var html = '<div class="field-label">Database <i class="fas fa-asterisk"></i></div>' +
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-database" data-append="true">' +
                        '<button type="button" class="dropdown-select">' +
                           (database_selected ? Util.htmlEntities((database_selected.notion_database_title.trim() !== '') ? database_selected.notion_database_title : 'No name') : '<span class="placeholder-text">No database selected</span>') +
                        '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by database name">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select">' + database_items + '</ul>' +
                        '</div>' +
                    '</div>';

        this.$el.find('.region-databases').html(html);
    },

    render: function() {
        var content = '';

        content += '<div class="progress-loader"></div>';
        content += '<div class="mask-light" style="display:none;"></div>';

        content += '<form class="form-fluid">' +
                        '<div class="modal-integration-innerscroll">' +
                            '<div class="row">' +
                                '<div class="region-databases">' +
                                    '<div class="field-label">Database <i class="fas fa-asterisk"></i></div>' +
                                    '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Title</div>' +
                                '<input type="text" name="title" maxlength="255" class="solid compact" placeholder="' + Util.htmlEntities(this.title) + '">' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Description</div>' +
                                '<textarea name="description" class="solid compact" rows="3"></textarea>' +
                            '</div>' +
                        '</div>' +
                        '<div class="modal-integration-innerscroll-footer">' +
                            '<button type="submit" class="primary" disabled>Send</button>' +
                        '</div>' +
                    '</form>';

        this.$el.html(content);

        if (this.form_value.title) {
            Form.setData(this.$el.find('form'), {
                title: this.form_value.title,
            });
        }

        if (!this.send_options) {
            this.loadSendOptions();
        }

        return this;
    }
});

export default Notion_Send;